export const SERVICE_TIMEOUT = 30000
export const SERVICE_TIMEOUT_MESSAGE = 'timeout'

export const SERVICE_IGNORE_MESSAGE: number[] = [403, 423]
